import{f as n}from"./__vite-currency.-J5FkzsG.js";import{e as y}from"./__vite-utils.DvSyEPnq.js";class b extends HTMLElement{constructor(){super(),this.itemsCount=null,this.headerPrice=null,this.stickyPrice=null,this.product=null,this.variant=null,this._subtotal=0,this._shipping=0,this._totalItems=0,this._bundles=[],this._addOns=[],this._addOns2=[],this._variantUpsells=[],this.total=0,this.cart={cartSubtotal:0,cartTotal:0,cartLines:[]}}connectedCallback(){this.itemsCount=this.querySelector('[js-product-summary="count"]'),this.headerPrice=this.querySelector('[js-product-summary="headerPrice"]'),this.stickyPrice=document.querySelector('[js-product-form="sticky-price"]'),this.summaryControl=this.querySelector(".product-summary__control"),this.summaryControl=this.querySelector(".product-summary__control"),this.variantLine=this.querySelector('[js-product-summary="variant"]'),this.getVariantOnLoad(),this.setEventListeners(),this.updateTotal()}set subtotal(t){this._subtotal=t,this.updateTotal()}get subtotal(){return this._subtotal}get bundles(){return this._bundles}get variantUpsells(){return this._variantUpsells}get addOns(){return this._addOns}get addOns2(){return this._addOns2}set shipping(t){this._shipping=t,this.updateTotal()}get shipping(){return this._shipping}get totalItems(){return this._totalItems}bundlesSetter(t){this._bundles=t,this.updateVariantLine()}variantUpsellsSetter(t){const{variant:e,selected:a}=t;a?this._variantUpsells=[...this._variantUpsells,e]:this._variantUpsells=this._variantUpsells.filter(i=>(i==null?void 0:i.id)!==(e==null?void 0:e.id)),this.updateVariantLine()}addOnsSetter(t){this._addOns=t,this.updateVariantLine()}addOns2Setter(t){this._addOns2=t,this.updateVariantLine()}setEventListeners(){this.summaryControl.addEventListener("click",()=>{this.toggleSummaryPanel()}),document.addEventListener("uwp-variant:update",t=>{const a=t.detail.variant;this.variant=a,this.updateVariantLine()}),y({eventName:"product-upsell:select",action:"listen",callback:t=>{const e=t;this.variantUpsellsSetter(e.detail)}}),y({eventName:"product-upsell:reset",action:"listen",callback:()=>{this._variantUpsells=[],this.updateVariantLine()}})}getVariantOnLoad(){const t=document.querySelector("uwp-product"),e=t==null?void 0:t._selectedVariant;this.product=t==null?void 0:t._product,setTimeout(()=>{const a=t._product;if(e)this.variant=e;else if(a!=null&&a.hasOnlyDefaultVariant){const i=a==null?void 0:a.variants[0];i.title=a==null?void 0:a.title,this.variant=i}this.updateVariantLine()},0)}updateVariantLine(){var d,p,h,_,v,g;if(!this.variant)return;const t=this.variant.available?window.themeVars.strings.product.stock.inStock:window.themeVars.strings.product.stock.outOfStock,e=this.variant.isPreorder,a=this.variant.preorderDate;let i="",m="";const l=window.themeVars.config.currencyCodes.inPdp;if((d=this.product)!=null&&d.icon_label&&(m=`
        <div class="product-summary__icon-label">
          ${this.product.icon_label.icon?`<img
                src="${this.product.icon_label.icon}"
                width="16"
                height="16"
                alt=""
              />`:""}
          <span class="text-small">
            ${(h=(p=this.product)==null?void 0:p.icon_label)==null?void 0:h.label}
          </span>
        </div>
      `),this.variant.available?i=`
        <div class="product-summary__stock">
          <span class="product-summary__stock-indicator product-summary__stock-indicator--in-stock"></span>
          <span class="product-summary__stock-label">${t}</span>
        </div>
      `:e?i=`
          <div class="product-summary__stock">
            <span class="product-summary__stock-indicator product-summary__stock-indicator--preorder"></span>
            <span class="product-summary__stock-label">${window.themeVars.strings.product.stock.preOrder}</span>
            <span class="product-summary__stock-label">${a}</span>
          </div>
        `:i=`
          <div class="product-summary__stock">
            <span class="product-summary__stock-indicator product-summary__stock-indicator--out-of-stock"></span>
            <span class="product-summary__stock-label">${t}</span>
          </div>
        `,this.variantLine&&this.bundles.length==0){const s=((_=this.variant)==null?void 0:_.compare_at_price)??0,r=this.variant.price,c=s>r,o=((v=this.variant)==null?void 0:v.imageAlt)||"";this.variantLine.innerHTML=`
        <div class="product-summary__item product-summary__item-variant">
          <div class="product-summary__item-image-wrapper">
            <img alt="${o}" src="${this.variant.imageUrl}?width=140&height=140" width="70" height="70" class="product-summary__item-image" />
          </div>
          <div class="product-summary__item-content">
            <div class="product-summary__item-details">
              <h6 class="product-summary__item-name text-large">
                ${((g=this.product)==null?void 0:g.title)||this.variant.title}
              </h6>
              ${m}
            </div>
            <div class="product-summary__item-price text-right ${c?"is-on-sale":""}">
              <span>
                <span class="visually-hidden">
                  ${window.themeVars.strings.product.price.sale}
                </span>

                ${c?`<span class="compare-at-price">
                        ${n({amount:s,inCents:!1,showCurrencyCode:l})}
                      </span>`:""}
              </span>

              <span>
                <span class="visually-hidden">
                  ${window.themeVars.strings.product.price.regular}
                </span>
                ${n({amount:r,inCents:!1,showCurrencyCode:l})}
              </span>
            </div>
          </div>
        </div>
        ${i}
      `}if(this.bundles.length>0){const s=this.variant.compare_at_price??0,r=this.variant.price,c=s>r;this.variantLine.innerHTML=this.bundles.map(o=>{var u;return`
            <div class="product-summary__item product-summary__item-variant">
              <div class="product-summary__item-image-wrapper">
                <img src="${(u=o.image)==null?void 0:u.url}?width=140&height=140" width="70" height="70" class="product-summary__item-image" />
              </div>
              <div class="product-summary__item-content">
                <div class="product-summary__item-details">
                  <h6 class="product-summary__item-name text-large">
                    ${o.productTitle}
                  </h6>
                  ${i}
                </div>
                ${c&&`<span class="compare-at-price">
                    ${n({amount:s,inCents:!1,showCurrencyCode:l})}
                  </span>`}
                ${n({amount:r,inCents:!1,showCurrencyCode:l})}
              </div>
            </div>
          `}).join("")}this.variantUpsells.length>0&&(this.variantLine.innerHTML+=this.variantUpsells.map(s=>{const r=s.compare_at_price??0,c=s.price,o=Number(r)>Number(c);return`
            <div class="product-summary__item product-summary__item-variant">
              <div class="product-summary__item-image-wrapper">
                <img alt="${(s==null?void 0:s.imageAlt)||""}" src="${s.imageUrl}?width=140&height=140" width="70" height="70" class="product-summary__item-image" />
              </div>
              <div class="product-summary__item-content">
                <div class="product-summary__item-details">
                  <h6 class="product-summary__item-name text-large">
                    ${s.productTitle||s.title}
                  </h6>
                </div>
                <div class="product-summary__item-price text-right ${o?"is-on-sale":""}">
                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.sale}
                    </span>

                    ${o?`<span class="compare-at-price">
                            ${n({amount:r,showCurrencyCode:l})}
                          </span>`:""}
                  </span>

                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.regular}
                    </span>

                    ${n({amount:c,showCurrencyCode:l})}
                  </span>
                </div>
              </div>
            </div>
            ${i}
          `}).join("")),this.addOns.length>0&&(this.variantLine.innerHTML+=this.addOns.map(s=>{const r=s.compare_at_price??0,c=s.price,o=Number(r)>Number(c);return`
            <div class="product-summary__item product-summary__item-variant">
              <div class="product-summary__item-image-wrapper">
                <img alt="${(s==null?void 0:s.imageAlt)||""}" src="${s.imageUrl}?width=140&height=140" width="70" height="70" class="product-summary__item-image" />
              </div>
              <div class="product-summary__item-content">
                <div class="product-summary__item-details">
                  <h6 class="product-summary__item-name text-large">
                    ${s.productTitle||s.title}
                  </h6>
                </div>
                <div class="product-summary__item-price text-right ${o?"is-on-sale":""}">
                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.sale}
                    </span>

                    ${o?`<span class="compare-at-price">
                            ${n({amount:r,inCents:!1,showCurrencyCode:l})}
                          </span>`:""}
                  </span>

                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.regular}
                    </span>

                    ${n({amount:c,inCents:!1,showCurrencyCode:l})}
                  </span>
                </div>
              </div>
            </div>
            ${i}
          `}).join("")),this.addOns2.length>0&&(this.variantLine.innerHTML+=this.addOns2.map(s=>{const r=s.compare_at_price??0,c=s.price,o=Number(r)>Number(c);return`
            <div class="product-summary__item product-summary__item-variant">
              <div class="product-summary__item-image-wrapper">
                <img alt="${(s==null?void 0:s.imageAlt)||""}" src="${s.imageUrl}?width=140&height=140" width="70" height="70" class="product-summary__item-image" />
              </div>
              <div class="product-summary__item-content">
                <div class="product-summary__item-details">
                  <h6 class="product-summary__item-name text-large">
                    ${s.productTitle||s.title}
                  </h6>
                </div>
                <div class="product-summary__item-price text-right ${o?"is-on-sale":""}">
                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.sale}
                    </span>

                    ${o?`<span class="compare-at-price">
                          ${n({amount:r,inCents:!1,showCurrencyCode:l})}
                        </span>`:""}
                  </span>

                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.regular}
                    </span>

                    ${n({amount:c,inCents:!1,showCurrencyCode:l})}
                  </span>
                </div>
              </div>
            </div>
            ${i}
          `}).join("")),this.updateCartSubtotal()}toggleSummaryPanel(){const t=this.classList.toggle("is-active");this.summaryControl.setAttribute("aria-expanded",t.toString())}updateTotal(){this.total=this._subtotal+this._shipping,this.cart.cartSubtotal=this._subtotal,this.cart.cartTotal=this.total,this._totalItems=this.cart.cartLines.length,this.renderTotal(),this.renderHeaderPrice()}renderTotal(){const t=this.querySelector('[js-product-summary="total-value"]');if(!t)return;let e=this.bundles.length>0?0:this.total;this.bundles.forEach(i=>e+=Number(i.price.amount)),this.variantUpsells.forEach(i=>e+=Number(i.price)/100),this.addOns.forEach(i=>e+=Number(i.price)),this.addOns2.forEach(i=>e+=Number(i.price));const a=window.themeVars.config.currencyCodes.inPdp;t.textContent=n({amount:e,inCents:!1,showCurrencyCode:a})}renderSubtotal(){const t=this.querySelector('[js-product-summary="subtotal-value"]');if(!t)return;let e=this.bundles.length>0?0:this._subtotal;this.bundles.forEach(i=>e+=Number(i.price.amount)),this.variantUpsells.forEach(i=>e+=Number(i.price)/100),this.addOns.forEach(i=>e+=Number(i.price)),this.addOns2.forEach(i=>e+=Number(i.price));const a=window.themeVars.config.currencyCodes.inPdp;t.textContent=n({amount:e,inCents:!1,showCurrencyCode:a})}renderItemsCount(){if(!this.itemsCount)return;const t=(this.bundles.length||1)+this.variantUpsells.length+this.addOns.length+this.addOns2.length;this.itemsCount.textContent=`(${t})`}renderHeaderPrice(){if(!this.headerPrice)return;let t=this.bundles.length>0?0:this.total;if(this.bundles.forEach(a=>t+=Number(a.price.amount)),this.variantUpsells.forEach(a=>t+=Number(a.price)/100),this.addOns.forEach(a=>t+=Number(a.price)),this.addOns2.forEach(a=>t+=Number(a.price)),!t)return;const e=window.themeVars.config.currencyCodes.inPdp;this.headerPrice.textContent=n({amount:t,inCents:!1,showCurrencyCode:e}),this.stickyPrice&&(this.stickyPrice.textContent=n({amount:t,inCents:!1,showCurrencyCode:e}))}addProductLine(t){this.cart.cartLines.push(t),this.updateCartSubtotal()}removeProductLine(t){this.cart.cartLines=this.cart.cartLines.filter(e=>e.id!==t),this.updateCartSubtotal()}updateCartSubtotal(){this._subtotal=this.cart.cartLines.reduce((t,e)=>t+e.price,0),this._subtotal+=this.variant?Number(this.variant.price):0,this.renderSubtotal(),this.renderItemsCount(),this.renderHeaderPrice(),this.updateTotal()}}customElements.define("uwp-product-summary",b);
